import wretch from 'wretch';
import * as v from 'valibot';
import { SessionSchema, TSessionDetails } from '@api/io/session.io';
import { localizedErrorHandlers } from '@fe-core';
import { EnrollmentRequestSchema } from '@api/io/session.enrollment.io';
import { DisenrollmentRequestSchema } from '@api/io/session.disenrollment.io';
import {
  SessionChildrenSchema,
  TSessionChildren,
} from '@api/io/session.children.io';

export const getSession = async ({
  baseUrl,
  sessionId,
}: {
  baseUrl: string;
  sessionId: string;
}): Promise<TSessionDetails> => {
  const url = `${baseUrl}/cat/sessions/${sessionId}`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(SessionSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-catalog | getSession | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid getSessions response');
    }
  });
};

export const getSessionChildren = async ({
  baseUrl,
  sessionId,
}: {
  baseUrl: string;
  sessionId: string;
}): Promise<TSessionChildren> => {
  const url = `${baseUrl}/cat/sessions/${sessionId}/children`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(SessionChildrenSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-catalog | getSessionChildren | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid getSessionChildren response');
    }
  });
};

type TEnrollmentRequest = v.Input<typeof EnrollmentRequestSchema>;
export const enroll = async ({
  baseUrl,
  sessionId,
}: {
  baseUrl: string;
  sessionId: number;
}): Promise<TEnrollmentRequest> => {
  const url = `${baseUrl}/cat/sessions/${sessionId}/enroll`;
  const instance = wretch(url, {
    credentials: 'include',
  }).post();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(EnrollmentRequestSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-catalog | enroll session | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid enroll response');
    }
  });
};

type TDisenrollmentRequest = v.Input<typeof DisenrollmentRequestSchema>;
export const disenroll = async ({
  baseUrl,
  sessionId,
}: {
  baseUrl: string;
  sessionId: number;
}): Promise<TDisenrollmentRequest> => {
  const url = `${baseUrl}/cat/sessions/${sessionId}/disenroll`;
  const instance = wretch(url, {
    credentials: 'include',
  }).post();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(DisenrollmentRequestSchema, response);

    if (validatedResponse?.success) {
      return validatedResponse.output;
    } else {
      console.error(
        'fe-learner-catalog | disenroll session | ',
        validatedResponse.issues,
      );
      throw new Error('Invalid disenroll response');
    }
  });
};
